export function formatDate(date) {
  if (!date) return ''
  
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }

  return new Date(date).toLocaleDateString('es-CO', options)
}

export function formatCurrency(value) {
  if (value === null || value === undefined) return '$0'
  
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
} 